// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"5bdf45545dc5bb73a719","465":"71b72e0af98db75d2746"}[chunkId] + ".js";
};